import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import debounce from "lodash/debounce";

export default class BackboneListener extends React.Component {
  static propTypes = {
    listenTo: PropTypes.oneOfType([
      PropTypes.instanceOf(Backbone.Model),
      PropTypes.instanceOf(Backbone.Collection),
    ]),
    events: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.func.isRequired, // () => Element
    debounceRender: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  };

  componentDidMount() {
    this._isMounted = true;

    this._listenTo(this.props);
  }

  componentWillUnmount() {
    this._isMounted = false;

    this._stopListeningTo(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.listenTo === nextProps.listenTo &&
      this.props.events === nextProps.events &&
      this.props.debounceRender === nextProps.debounceRender
    ) {
      return;
    }

    this._stopListeningTo(this.props);
    this._listenTo(nextProps);
  }

  _listenTo({ listenTo, events, debounceRender }) {
    if (listenTo == null) {
      return;
    }
    const shouldDebounce =
      debounceRender === true || typeof debounceRender === "number";
    let debounceAmount = debounceRender;
    if (debounceRender === true) {
      debounceAmount = 0;
    }
    const listener = shouldDebounce
      ? debounce(this._forceUpdateIfMounted, debounceAmount)
      : this._forceUpdateIfMounted;
    listenTo.on(events.join(" "), listener, this);
  }

  _stopListeningTo({ listenTo }) {
    if (listenTo == null) {
      return;
    }
    listenTo.off(null, null, this);
  }

  _forceUpdateIfMounted = () => {
    if (!this._isMounted) {
      return;
    }

    this.forceUpdate();
  };

  render() {
    return this.props.children();
  }
}



// WEBPACK FOOTER //
// ./src/components/BackboneListener.jsx